<div class="disclaimer-wrapper">
  <span class="poi-disclaimer" >{{disclaimer?.text}}, you can </span>

  <span class="link-like-text" (click)="handleZoomInClick(disclaimer?.visibleOnZoom?.min!)">zoom in</span>
</div>
